module.exports = __webpack_public_path__ + "img/layers.abf1f51b.gif";